import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { PreSignupFlowContext } from '@/components/PreSignupFlow/PreSignupProvider';
import { useAnalytics } from '@/hooks/analytics';

import Poll from '../../../Components/Poll';
import { getChoicesFromTiles, onSelectChoice } from '../utils';
import { PollWrapper } from './styles';

interface Props {
	compact?: boolean;
}

const PollSingleClickUpdated = ({ compact }: Props) => {
	const { formatMessage } = useIntl();
	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { questionType, tiles, question, questionSubtitle, questionNumber, totalQuestions } = ActiveScreen;
	const { logEvent, logEventAsync } = useAnalytics();

	async function onComplete(choiceIds: string[]): Promise<void> {
		const choiceId = choiceIds[0];
		const selectedTile = tiles?.find(tile => tile.id === choiceId);
		if (!selectedTile) {
			return;
		}

		logEvent({
			eventName: 'FTUE : Intro Questions : Proceeded',
			eventProps: {
				choices: [choiceId],
				num_choices: 1,
				question_type: questionType as string,
			},
		});
		nextScreen();
	}

	return (
		<PollWrapper>
			<Poll
				key={questionType}
				title={question && formatMessage(question)}
				choices={getChoicesFromTiles(tiles, formatMessage)}
				onSelectChoice={(choiceId: string) => onSelectChoice(choiceId, questionType, logEventAsync)}
				onComplete={onComplete}
				compact={compact}
				subtitle={questionSubtitle && formatMessage(questionSubtitle)}
				questionCount={{
					current: questionNumber,
					total: totalQuestions,
				}}
			/>
		</PollWrapper>
	);
};

export default PollSingleClickUpdated;
